import moment from 'moment-timezone';
import { parseWallClock } from './native-dates';

export {
  parseWallClock,
  getInternationalDateTz,
  getInternationalYear,
  getInternationalDMY,
  getInternationalFullDate,
  getInternationalTime,
  getInternationalWeekDateTz,
  getInternationalTimeShort,
  getInternationalFullDateDynamic,
  isToday,
} from './native-dates';

export const tpDateParser = (date: string) => {
  return new Intl.DateTimeFormat('en-GB')
    .format(new Date(date))
    .split('/')
    .reverse()
    .join('-');
};

/**
 *
 * @param str date string input
 * @returns date format D MMM, yyyy
 */
export const dateStringToFriendlyDate = (str: string) => {
  return moment(str).format('D MMM, yyyy');
};

/**
 *
 * @param str date string input
 * @returns date format D MMM, yyyy
 */
export const dateStringToFriendlyDateUTC = (str: string) => {
  return moment(str.substring(0, 10)).format('D MMM, yyyy');
};

/**
 *
 * @param str date string input
 * @returns date format mm/dd/yyyy
 */
export const dateToInputDateFormat = (date: Date) => {
  return moment(date.toISOString()).format('MM/DD/yyyy');
};

/**
 *
 * @param str date format mm/dd/yyyy
 */
export const dateStringToDateFormat = (str: string) => {
  const [month, day, year] = str.split('/');

  return new Date(+year, +month - 1, +day).toISOString();
};

/**
 * Format an event date/time (moment tokens) as the venue's wall clock. Falls back to the legacy
 * America/New_York conversion only for non-ISO input. '' when the value isn't a date.
 */
export const formatEventDate = (
  date: string | undefined | null,
  format: string
) => {
  if (!date) return '';
  const wall = parseWallClock(date);
  if (wall) return moment.utc(wall).format(format);
  const legacy = moment(date);
  return legacy.isValid() ? legacy.tz('America/New_York').format(format) : '';
};
